var _rect, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokerCollaborateIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 520 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 344,
    rx: 16,
    fill: "#62A1FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255.217,
    cy: 170.5,
    r: 136.541,
    stroke: "#001D6C",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_91_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.082,
    y: 152.541,
    width: 35.918,
    height: 35.918,
    rx: 17.959,
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.671 177.289C385.671 174.36 388.045 171.986 390.974 171.986H397.54C400.469 171.986 402.843 174.36 402.843 177.289C402.843 178.265 402.052 179.057 401.076 179.057H387.438C386.462 179.057 385.671 178.265 385.671 177.289Z",
    fill: "#0043CE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.509,
    cy: 165.167,
    r: 5.47167,
    fill: "#0043CE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_91_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 29,
    width: 35.918,
    height: 35.918,
    rx: 17.959,
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.588 53.7481C299.588 50.8192 301.962 48.4448 304.891 48.4448H311.457C314.386 48.4448 316.761 50.8192 316.761 53.7481C316.761 54.7244 315.969 55.5159 314.993 55.5159H301.356C300.379 55.5159 299.588 54.7244 299.588 53.7481Z",
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.426,
    cy: 41.6265,
    r: 5.47167,
    fill: "#001D6C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_91_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.576,
    y: 250.504,
    width: 35.918,
    height: 35.918,
    rx: 17.959,
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.167 275.253C149.167 272.324 151.541 269.949 154.47 269.949H161.036C163.965 269.949 166.339 272.324 166.339 275.253C166.339 276.229 165.548 277.02 164.571 277.02H150.934C149.958 277.02 149.167 276.229 149.167 275.253Z",
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.005,
    cy: 263.13,
    r: 5.47167,
    fill: "#001D6C"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_91_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.504,
    y: 247.504,
    width: 35.918,
    height: 35.918,
    rx: 17.959,
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.093 272.252C344.093 269.323 346.467 266.949 349.396 266.949H355.962C358.891 266.949 361.265 269.323 361.265 272.252C361.265 273.228 360.474 274.02 359.498 274.02H345.861C344.884 274.02 344.093 273.228 344.093 272.252Z",
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.93,
    cy: 260.13,
    r: 5.47167,
    fill: "#001D6C"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_91_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 149,
    width: 35.918,
    height: 35.918,
    rx: 17.959,
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.589 173.748C108.589 170.819 110.963 168.444 113.892 168.444H120.458C123.387 168.444 125.761 170.819 125.761 173.748C125.761 174.724 124.97 175.515 123.994 175.515H110.357C109.38 175.515 108.589 174.724 108.589 173.748Z",
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.426,
    cy: 161.626,
    r: 5.47167,
    fill: "#001D6C"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_91_5025)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.704,
    y: 81.311,
    width: 179.59,
    height: 179.59,
    rx: 89.7951,
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.169,
    cy: 183.328,
    r: 26.9385,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.353,
    y: 192.307,
    width: 94.9262,
    height: 41.0492,
    rx: 6.77157,
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.353,
    y: 176.914,
    width: 64.1393,
    height: 56.4426,
    rx: 5.13115,
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.853,
    y: 164.086,
    width: 38.4836,
    height: 69.2705,
    rx: 5.13115,
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.508,
    y: 192.307,
    width: 38.4836,
    height: 41.0492,
    rx: 5.13115,
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.226,
    y: 144.844,
    width: 48.7459,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.705,
    y: 221.821,
    width: 182.832,
    height: 50.7868,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.336,
    y: 140.996,
    width: 23.0902,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.921 145.554V221.812H300.757V116.966C300.757 113.216 296.866 110.733 293.465 112.312L231.891 140.9C230.08 141.741 228.921 143.556 228.921 145.554Z",
    fill: "#0043CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.886 180.663V221.812H283.439V193.27C283.439 190.841 281.736 188.744 279.358 188.247L219.067 175.641C215.88 174.974 212.886 177.407 212.886 180.663Z",
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.824 205.135C239.824 202.301 242.121 200.004 244.955 200.004H250.086C252.92 200.004 255.217 202.301 255.217 205.135V221.811H239.824V205.135Z",
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.824,
    y: 164.086,
    width: 20.5246,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.824,
    y: 149.975,
    width: 20.5246,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.623,
    y: 115.34,
    width: 38.4836,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.057,
    y: 115.34,
    width: 48.7459,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.037,
    y: 111.492,
    width: 23.0902,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.328,
    y: 164.086,
    width: 20.5246,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.328,
    y: 149.975,
    width: 20.5246,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.328,
    y: 135.865,
    width: 20.5246,
    height: 7.69672,
    rx: 3.84836,
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_91_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 31,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0043CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.955 49.8223C146.119 48.6761 147.105 47.7949 148.297 47.7949H153.703C154.895 47.7949 155.88 48.6761 156.044 49.8223H157.758C159.811 49.8223 161.475 51.4864 161.475 53.5392V73.8132C161.475 75.866 159.811 77.5301 157.758 77.5301H144.242C142.189 77.5301 140.525 75.866 140.525 73.8132V53.5392C140.525 51.4864 142.189 49.8223 144.242 49.8223H145.955ZM145.955 51.8497H144.242C143.309 51.8497 142.552 52.6061 142.552 53.5392V73.8132C142.552 74.7463 143.309 75.5027 144.242 75.5027H157.758C158.691 75.5027 159.447 74.7463 159.447 73.8132V53.5392C159.447 52.6061 158.691 51.8497 157.758 51.8497H156.044C155.88 52.996 154.895 53.8771 153.703 53.8771H148.297C147.105 53.8771 146.119 52.996 145.955 51.8497ZM154.041 51.5118C154.041 51.6984 153.89 51.8497 153.703 51.8497H148.297C148.11 51.8497 147.959 51.6984 147.959 51.5118V50.1602C147.959 49.9736 148.11 49.8223 148.297 49.8223H153.703C153.89 49.8223 154.041 49.9736 154.041 50.1602V51.5118ZM145.587 58.8104C145.587 58.2506 146.041 57.7967 146.601 57.7967H155.387C155.946 57.7967 156.4 58.2506 156.4 58.8104C156.4 59.3703 155.946 59.8241 155.387 59.8241H146.601C146.041 59.8241 145.587 59.3703 145.587 58.8104ZM145.587 64.0141C145.587 63.4542 146.041 63.0004 146.601 63.0004H155.387C155.946 63.0004 156.4 63.4542 156.4 64.0141C156.4 64.5739 155.946 65.0278 155.387 65.0278H146.601C146.041 65.0278 145.587 64.5739 145.587 64.0141ZM145.587 69.1333C145.587 68.5734 146.041 68.1196 146.601 68.1196H153.027C153.587 68.1196 154.041 68.5734 154.041 69.1333C154.041 69.6931 153.587 70.147 153.027 70.147H146.601C146.041 70.147 145.587 69.6931 145.587 69.1333Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_91_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 135,
    width: 73,
    height: 73,
    rx: 36.5,
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.042 156.083C401.042 155.445 401.56 154.927 402.199 154.927H422.801C423.44 154.927 423.957 155.445 423.957 156.083V167.885C423.957 168.524 423.44 169.042 422.801 169.042H402.199C401.56 169.042 401.042 168.524 401.042 167.885V156.083ZM403.355 157.24V166.729H421.645V157.24H403.355ZM406.929 172.803C406.929 172.164 407.446 171.647 408.085 171.647H416.914C417.553 171.647 418.071 172.164 418.071 172.803C418.071 173.442 417.553 173.959 416.914 173.959H408.085C407.446 173.959 406.929 173.442 406.929 172.803ZM396.312 176.564C395.674 176.564 395.156 177.082 395.156 177.721C395.156 178.359 395.674 178.877 396.312 178.877H398.394V186.917C398.394 187.555 398.911 188.073 399.55 188.073C400.189 188.073 400.706 187.555 400.706 186.917V178.877H424.294V186.917C424.294 187.555 424.811 188.073 425.45 188.073C426.088 188.073 426.606 187.555 426.606 186.917V178.877H428.687C429.326 178.877 429.844 178.359 429.844 177.721C429.844 177.082 429.326 176.564 428.687 176.564H396.312Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_91_5025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 247,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.584 265.401C159.982 264.811 159.237 264.561 158.381 264.446C157.592 264.34 156.602 264.337 155.402 264.337H155.727V262.594C155.727 262.113 155.337 261.723 154.855 261.723C154.374 261.723 153.984 262.113 153.984 262.594V264.337H146.434V262.594C146.434 262.113 146.044 261.723 145.563 261.723C145.082 261.723 144.692 262.113 144.692 262.594V264.337H145.597C144.397 264.337 143.408 264.34 142.618 264.446C141.762 264.561 141.018 264.811 140.415 265.401C139.814 265.991 139.55 266.727 139.418 267.577C139.292 268.387 139.272 269.411 139.248 270.657L139.243 270.893C139.2 273.16 139.166 275.739 139.177 277.894C139.183 278.971 139.199 279.949 139.233 280.733C139.265 281.483 139.314 282.142 139.407 282.521C139.715 283.778 140.629 284.919 142.397 285.721C144.13 286.507 146.717 286.986 150.5 286.986C154.282 286.986 156.869 286.507 158.603 285.721C160.37 284.919 161.285 283.778 161.593 282.521C161.686 282.142 161.735 281.483 161.767 280.733C161.8 279.949 161.817 278.971 161.822 277.894C161.834 275.739 161.799 273.16 161.756 270.893L161.751 270.657C161.727 269.411 161.707 268.387 161.582 267.577C161.45 266.727 161.186 265.991 160.584 265.401ZM142.851 266.173C142.19 266.262 141.864 266.42 141.635 266.645C141.405 266.871 141.241 267.192 141.14 267.845C141.043 268.468 141.018 269.282 140.995 270.435H160.004C159.981 269.282 159.957 268.468 159.86 267.845C159.759 267.192 159.594 266.871 159.364 266.645C159.135 266.42 158.81 266.262 158.149 266.173C157.462 266.081 156.55 266.079 155.216 266.079H145.783C144.45 266.079 143.537 266.081 142.851 266.173ZM140.919 277.885C140.925 278.953 140.942 279.907 140.974 280.659C141.007 281.444 141.055 281.925 141.099 282.107C141.257 282.75 141.74 283.51 143.116 284.134C144.526 284.773 146.83 285.244 150.5 285.244C154.17 285.244 156.473 284.773 157.883 284.134C159.26 283.51 159.743 282.75 159.9 282.107C159.945 281.925 159.993 281.444 160.026 280.659C160.058 279.907 160.075 278.953 160.08 277.885C160.089 276.136 160.068 274.1 160.036 272.177H140.963C140.931 274.1 140.91 276.136 140.919 277.885Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.144 275.371C146.144 275.852 145.754 276.242 145.273 276.242C144.792 276.242 144.402 275.852 144.402 275.371C144.402 274.89 144.792 274.5 145.273 274.5C145.754 274.5 146.144 274.89 146.144 275.371Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.371 275.371C151.371 275.852 150.981 276.242 150.5 276.242C150.019 276.242 149.629 275.852 149.629 275.371C149.629 274.89 150.019 274.5 150.5 274.5C150.981 274.5 151.371 274.89 151.371 275.371Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.598 275.371C156.598 275.852 156.208 276.242 155.727 276.242C155.245 276.242 154.855 275.852 154.855 275.371C154.855 274.89 155.245 274.5 155.727 274.5C156.208 274.5 156.598 274.89 156.598 275.371Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.371 281.179C151.371 281.66 150.981 282.05 150.5 282.05C150.019 282.05 149.629 281.66 149.629 281.179C149.629 280.698 150.019 280.308 150.5 280.308C150.981 280.308 151.371 280.698 151.371 281.179Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.598 281.179C156.598 281.66 156.208 282.05 155.727 282.05C155.245 282.05 154.855 281.66 154.855 281.179C154.855 280.698 155.245 280.308 155.727 280.308C156.208 280.308 156.598 280.698 156.598 281.179Z",
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.144 281.179C146.144 281.66 145.754 282.05 145.273 282.05C144.792 282.05 144.402 281.66 144.402 281.179C144.402 280.698 144.792 280.308 145.273 280.308C145.754 280.308 146.144 280.698 146.144 281.179Z",
    fill: "#0078FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_91_5025",
    x: 368.496,
    y: 148.248,
    width: 53.0906,
    height: 53.0906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.29316
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.29316
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_91_5025",
    x: 282.414,
    y: 24.7068,
    width: 53.0906,
    height: 53.0906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.29316
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.29316
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_91_5025",
    x: 131.99,
    y: 246.211,
    width: 53.0906,
    height: 53.0906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.29316
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.29316
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_91_5025",
    x: 326.918,
    y: 243.211,
    width: 53.0906,
    height: 53.0906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.29316
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.29316
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_91_5025",
    x: 91.4137,
    y: 144.707,
    width: 53.0906,
    height: 53.0906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.29316
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.29316
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_91_5025",
    x: 145.083,
    y: 66.8967,
    width: 222.833,
    height: 222.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.20717
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8108
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_91_5025",
    x: 102.204,
    y: 19.8025,
    width: 97.5925,
    height: 97.5925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.59874
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.39812
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.113725 0 0 0 0 0.423529 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_91_5025",
    x: 361.566,
    y: 125.377,
    width: 101.869,
    height: 101.869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.81142
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.21713
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.113725 0 0 0 0 0.423529 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_91_5025",
    x: 108.566,
    y: 237.377,
    width: 83.8685,
    height: 83.8685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.81142
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.21713
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.113725 0 0 0 0 0.423529 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_5025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_5025",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_5025"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.704,
    y: 81.311,
    width: 179.59,
    height: 179.59,
    rx: 89.7951,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerCollaborateIllustration);
export default __webpack_public_path__ + "static/media/broker-collaborate-illustration.e8e200585bd345aaec2860e8462562fd.svg";
export { ForwardRef as ReactComponent };